import {
  ENTER_PRACTICE_NAME,
  ENTER_PRACTICE_EMAIL,
  ENTER_PRACTICE_PHONE,
  SELECT_HOW_DID_YOU_HEAR_ABOUT_US,
  SUBMIT_PRACTICE_INFO,
  SELECT_PRACTICE_TYPE,
  VALIDATE_PASSWORD,
  CONFIRM_PASSWORD,
  CREATE_ACCOUNT,
  ENTER_FIELD_DATA,
  SUBMIT_CONTACT_INFO,
  SUBMIT_BUSINESS_INFO,
  SELECT_PAYMENT_PLANS,
  ENTER_ROUTING_NUMBER,
  CONFIRM_ACCOUNT_NUMBER,
  SUBMIT_ACH_INFO,
  SIGN_AGREEMENT,
  CLEAN_ROUTING_ERRORS
} from '../actions';

import {
  UPDATE_MANAGEMENT_FIELD,
  SUBMIT_MANAGEMENT_INFO
} from '../actions/significantController';

import {
  ENTER_STREET,
  ENTER_APTSUITE,
  ENTER_CITY,
  SELECT_STATE,
  ENTER_ZIP
} from '../../components/address/actions';

const defaultState = {
  practiceName: null,
  practiceEmail: null,
  practicePhone: null,
  howDidYouHearAboutUs: null,
  additionalInfo: null,
  contactFirstname: null,
  contactLastname: null,
  doctorFirstname: null,
  doctorLastName: null,
  doctorEmail: null,
  street: null,
  aptsuite: null,
  city: null,
  state: null,
  zip: null,
  legalName: null,
  businessTIN: null,
  maxPNITerm: null,
  boSignificantOwnerFlag: true,
  achAccountName: null,
  achRoutingNumber: null,
  achBankName: null,
  achAccountNumber: null,
  achConfirmAccountNumber: null,
  signeeFirstName: null,
  signeeLastName: null,
  signeeTitle: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case ENTER_PRACTICE_NAME:
      if (action.errMsg) {
        return { ...state, practiceName: action.errMsg };
      }
      if (!action.errMsg || action.value) {
        return { ...state, practiceName: null };
      }
      return state;
    case ENTER_PRACTICE_EMAIL:
      if (action.errMsg) {
          return { ...state, practiceEmail: action.errMsg };
      }
      if (!action.errMsg || action.value) {
        return { ...state, practiceEmail: null };
      }
      return state;
    case ENTER_PRACTICE_PHONE:
      if (action.errMsg) {
          return { ...state, practicePhone: action.errMsg };
      }
      if (!action.errMsg || action.value) {
        return { ...state, practicePhone: null };
      }
      return state;
    case SELECT_HOW_DID_YOU_HEAR_ABOUT_US:
      if (action.errMsg) {
          return { ...state, howDidYouHearAboutUs: action.errMsg, additionalInfo: null };
      }
      if (!action.errMsg || action.value) {
        return { ...state, howDidYouHearAboutUs: null, additionalInfo: null };
      }
      return state;
    case SUBMIT_PRACTICE_INFO:
    case SUBMIT_CONTACT_INFO: {
      return { ...state, ...action.errors };
    }
    case SELECT_PRACTICE_TYPE:
      if (action.errMsg) {
        return { ...state, practiceType: action.errMsg };
      }
      return { ...state, practiceType: null };
    case VALIDATE_PASSWORD: {
      return { ...state, ...action.errors };
    }
    case CONFIRM_PASSWORD: {
      return { ...state, passwordConfirm: action.errMsg };
    }
    case CREATE_ACCOUNT: {
      if (action.errors) {
        return { ...state, ...action.errors };
      }
      return { ...state };
    }
    case ENTER_FIELD_DATA:
      const { fieldName, errMsg, value } = action;

      if (errMsg) {
        return { ...state, [fieldName]: errMsg };
      }

      if (!errMsg || value) {
        return { ...state, [fieldName]: null };
      }
      return state;
    case ENTER_STREET:
      if (action.errMsg) {
        return { ...state, street: action.errMsg };
      }
      if (!action.errMsg || action.value) {
        return { ...state, street: null };
      }
      return state;
    case ENTER_APTSUITE:
      if (action.errMsg) {
        return { ...state, aptsuite: action.errMsg };
      }
      if (!action.errMsg || action.value) {
        return { ...state, aptsuite: null };
      }
      return state;
    case ENTER_CITY:
      if (action.errMsg) {
        return { ...state, city: action.errMsg };
      }
      if (!action.errMsg || action.value) {
        return { ...state, city: null };
      }
      return state;
    case SELECT_STATE:
      if (action.errMsg) {
        return { ...state, state: action.errMsg };
      }
      if (!action.errMsg || action.value) {
        return { ...state, state: null };
      }
      return state;
    case ENTER_ZIP:
      if (action.errMsg) {
        return { ...state, zip: action.errMsg };
      }
      if (!action.errMsg || action.value) {
        return { ...state, zip: null };
      }
      return state;
    case SUBMIT_BUSINESS_INFO:
      return { ...state, ...action.errors };
    case SELECT_PAYMENT_PLANS:
      if (action.errMsg) {
        return { ...state, practiceMaxPNITerm: action.errMsg };
      }
      if (!action.errMsg || action.value) {
        return { ...state, practiceMaxPNITerm: null };
      }
      return state;
    case ENTER_ROUTING_NUMBER:
      const { errors } = action;
      let newState = state;
      if (errors) {
        if (errors.routingNumber) {
          newState = { ...state, achRoutingNumber: errors.routingNumber };
        }
        if (errors.bankName) {
          newState = { ...state, achBankName: errors.bankName };
        }
      }
      return newState;
    case CLEAN_ROUTING_ERRORS:
      return {...state, achRoutingNumber: null, achBankName: null}
    case CONFIRM_ACCOUNT_NUMBER:
      if (action.errMsg) {
        return { ...state, achConfirmAccountNumber: action.errMsg };
      }
      if (!action.errMsg || action.value) {
        return { ...state, achConfirmAccountNumber: null };
      }
      return state;
    case SUBMIT_ACH_INFO:
      return { ...state, ...action.errors };
    case SIGN_AGREEMENT:
      return { ...state, ...action.errors };
    case UPDATE_MANAGEMENT_FIELD: {
      const { field, errMsg } = action;
      return { ...state, [field]: errMsg };
    }
    case SUBMIT_MANAGEMENT_INFO: {
      return {...state, ...action.errors};
    }
    default:
      return state;
  }
};

